import { PudoTransactionTimerPickUpPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface AwaitingPickUpProps {
    accountId: string;
    navigateUrl?: string;
}

export const AwaitingPickUp = ({ accountId, navigateUrl }: AwaitingPickUpProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='pudo-dashboard.awaiting-pick-up'
                defaultMessage='Awaiting pick-up'
            />
        }
        Chart={PudoTransactionTimerPickUpPendingWaitingDaysStackedBarChart}
    />
);

export default AwaitingPickUp;
